import createResumePointsIntervalStream from './Streams/createResumePointsIntervalStream';
import createPlaybackSeekStream from './Streams/createPlaybackSeekStream';
import createResumePointsTriggerStream from './Streams/createResumePointsTriggerStream';
import subscribeToResumePointsTrigger from './Subscribers/subscribeToResumePointsTrigger';

const connectResumePointsApiSubscriptions = middleware => {
    const { player, state } = middleware;

    middleware.apiServices.resumePoints.response$
        .subscribe(() => {
            // TODO to be added to the error handling logic
        });

    return [
        subscribeToResumePointsTrigger(
            createResumePointsTriggerStream(
                createResumePointsIntervalStream(
                    player.state.stores.playback.update$,
                    state.stores.resumePoints.update$
                ),
                createPlaybackSeekStream(
                    player.state.stores.playback.update$,
                    state.stores.resumePoints.update$
                ),
                state.stores.config.update$,
                state.stores.playback.update$,
                player.state.stores.playback.update$,
            ),
            middleware.apiServices.resumePoints.request$
        ),
    ];
};

export default connectResumePointsApiSubscriptions;

